import * as angular from 'angular';

import { OrganizationHelpers } from '@mode/legacy/data-access-model-js';

class ConnectionsController {
  private orgToken: string;
  private selectDataSourcesLink: string;

  static $inject = ['accountContext'];

  constructor(private accountContext) {}

  $onInit() {
    this.orgToken = this.accountContext.token;
    this.selectDataSourcesLink = OrganizationHelpers.getSelectDataSourcesLink(this.accountContext._resource);
  }
}

export const ConnectionsComponent: angular.IComponentOptions = {
  controller: ConnectionsController,
  controllerAs: 'ctrl',
  bindings: {},
  template: `
    <div class="connections-panel">
      <div class="connections-panel-header">
        <div class="header-title">
          <h3 class="heading">Manage Connections</h3>
        </div>
        <div class="header-actions">
          <a ng-href="{{ ctrl.selectDataSourcesLink }}?trk_element_id=9"
             rel="noopener"
             target="_blank">
            <capra-button class="action-button invite-button" text="Connect a database">
            </capra-button>
          </a>
        </div>
      </div>
      <div class="connections-panel-body">
        <connections-browser org-token="ctrl.orgToken" />
      </div>
    </div>
  `,
};
